import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import { paths } from "config/paths";
import { useRouter } from "next/router";

import { PortalActionCard } from "~ui-components/components/molecules/portal-action-card";

import { ItemCard } from "./items/item-card";

import { DataViewProps } from ".";

export function DataPortalLargeView(props: DataViewProps) {
	const router = useRouter();

	const {
		isLoading,
		items,
		onItemDelete,
		isImportDataAllowed,
		isDeleteDataAllowed,
	} = props;

	return (
		<Box
			sx={{
				display: "grid",
				gap: 4,
				gridTemplateColumns: {
					xs: "1fr",
					sm: "repeat(1, 1fr)",
					md: "repeat(2, 1fr)",
				},
			}}>
			{isImportDataAllowed && (
				<PortalActionCard
					title="Import Data"
					href={paths.accountName.data.import(router.query["account-name"])}
				/>
			)}
			{isLoading && (
				<Box sx={{ p: 2 }}>
					<CircularProgress />
				</Box>
			)}
			{Array.from(items.values()).map((item) => (
				<ItemCard
					size="large"
					item={item}
					key={item.id}
					onDelete={onItemDelete}
					isDeleteDataAllowed={isDeleteDataAllowed}
				/>
			))}
		</Box>
	);
}
